const Equipmament = {
  title: 'INATIVAR EQUIPAMENTOS'
}

export default Equipmament;
